import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/Button';
export function Navigation() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToSection = (id: string) => {
    setIsMobileMenuOpen(false);
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  const navLinks = [{
    name: 'Science',
    id: 'mechanism'
  }, {
    name: 'Evidence',
    id: 'evidence'
  }, {
    name: 'Training',
    id: 'training'
  }];
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md py-4' : 'bg-transparent py-6'}`} data-id="element-121">
      <div className="container mx-auto px-4 flex items-center justify-between" data-id="element-122">
        {/* Logo */}
        <button onClick={() => scrollToSection('hero')} className={`text-2xl font-bold tracking-tighter transition-colors ${isScrolled ? 'text-teal-600' : 'text-white'}`} data-id="element-123">
          VABYSMO
        </button>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center space-x-8" data-id="element-124">
          {navLinks.map(link => <button key={link.name} onClick={() => scrollToSection(link.id)} className={`text-sm font-medium transition-colors hover:text-teal-500 ${isScrolled ? 'text-slate-600' : 'text-slate-200'}`} data-id="element-125">
              {link.name}
            </button>)}
          <Button size="sm" variant={isScrolled ? 'primary' : 'outline'} className={!isScrolled ? 'text-white border-white hover:bg-white hover:text-slate-900 hover:border-white' : ''} onClick={() => scrollToSection('training')} data-id="element-126">
            Get Started
          </Button>
        </div>

        {/* Mobile Menu Button */}
        <button className="md:hidden p-2" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" data-id="element-127">
          {isMobileMenuOpen ? <X className={isScrolled ? 'text-slate-900' : 'text-white'} data-id="element-128" /> : <Menu className={isScrolled ? 'text-slate-900' : 'text-white'} data-id="element-129" />}
        </button>
      </div>

      {/* Mobile Menu Drawer */}
      {isMobileMenuOpen && <div className="absolute top-full left-0 right-0 bg-white shadow-xl border-t border-slate-100 p-4 md:hidden flex flex-col space-y-4 animate-in slide-in-from-top-5" data-id="element-130">
          {navLinks.map(link => <button key={link.name} onClick={() => scrollToSection(link.id)} className="text-left px-4 py-3 text-slate-600 font-medium hover:bg-slate-50 rounded-lg" data-id="element-131">
              {link.name}
            </button>)}
          <Button onClick={() => scrollToSection('training')} className="w-full" data-id="element-132">
            Get Started
          </Button>
        </div>}
    </nav>;
}